/**
 * Button Component
 * A reusable bordered button component
 */
import React from 'react'

interface BorderedButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  action?: () => void
  children?: React.ReactNode
  className?: string
  disabled?: boolean
}

export default function BorderedButton ({
  action,
  children,
  className,
  disabled = false,
  ...props
}: BorderedButtonProps): React.JSX.Element {
  return (
    <button
      onClick={action}
      data-testid="bordered-button"
      disabled={disabled}
      className={`
        group cursor-pointer font-semibold relative w-full flex justify-center p-2.5 border border-neutrals-400 
        leading-relaxed text-sm font-medium rounded-3xl text-neutrals-800 bg-white hover:bg-neutrals-100 
        focus:outline-none disabled:bg-neutrals-400 disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  )
}
